import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SalRoutingModule } from './sal-routing.module';
import { AdminModule } from '../admin/admin.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { AlertModule, BsDatepickerModule, TypeaheadModule } from 'ngx-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxEditorModule } from 'ngx-editor';
import { SaleOrderComponent } from './sale-order/sale-order.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { SalePaymentComponent } from './sale-payment/sale-payment.component';
import { ServiceRenewalComponent } from './service-renewal/service-renewal.component';
import { SaleSubscriptionComponent } from './sale-subscription/sale-subscription.component';
import { PayComponent } from './pay/pay.component';
import { CreateOrderComponent } from './create-order/create-order.component';
import { SuperAdminModule } from '../superadmin/superadmin.module';
import { InvoiceReceiptComponent } from './invoice-receipt/invoice-receipt.component';
import { SuccessComponent } from './success/success.component';
import { InvoicePrintComponent } from './invoice-print/invoice-print.component';
import { AdminSaleOrderComponent } from './admin-sale-order/admin-sale-order.component';
import { AdminInvoiceComponent } from './admin-invoice/admin-invoice.component';
import { AdminServiceRenewalComponent } from './admin-service-renewal/admin-service-renewal.component';
import { AdminInvoicePaymentComponent } from './admin-invoice-payment/admin-invoice-payment.component';
import { AdminInvoiceReceiptComponent } from './admin-invoice-receipt/admin-invoice-receipt.component';
import { PayoutPayComponent } from './payout-pay/payout-pay.component';
import { PayoutHistoryComponent } from './payout-history/payout-history.component';


@NgModule({
  declarations: [SaleOrderComponent, InvoiceComponent,SalePaymentComponent, ServiceRenewalComponent,
    SaleSubscriptionComponent, PayComponent, CreateOrderComponent, InvoiceReceiptComponent, 
    SuccessComponent, InvoicePrintComponent, AdminSaleOrderComponent, AdminInvoiceComponent, AdminServiceRenewalComponent, AdminInvoicePaymentComponent, AdminInvoiceReceiptComponent, PayoutPayComponent, PayoutHistoryComponent],
  imports: [
    CommonModule,
    SalRoutingModule,
    AdminModule,
    SuperAdminModule,
    NgbModule,
    FormsModule,
    AlertModule.forRoot(),
    BsDatepickerModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    NgxEditorModule,
    TypeaheadModule.forRoot()
    
   
  ]
})
export class SalModule { }
